export const letterL = {
  nouns: [
    {"shop": ["Laden", "Läden", "der", "die", "m"]},
    {"country": ["Land", "Länder", "das", "die", "n"]},
    {"life": ["Leben", "Leben", "das", "die", "n"]},
    {"food": ["Lebensmittel", "Lebensmittel", "die", "die", "f"]},
    {"teacher": ["Lehrer", "Lehrer", "der", "die", "m"]},
    {"people": ["Leute", "Leute", "die", "die", "f"]},
    {"light": ["Licht", "Lichter", "das", "die", "n"]},
    {"song": ["Lied", "Lieder", "das", "die", "n"]},
    {"truck": ["Lkw", "Lkws", "der", "die", "m"]},
    {"restaurant": ["Lokal", "Lokale", "das", "die", "n"]},
    {"solution": ["Lösung", "Lösungen", "die", "die", "f"]}
  ],
  verbs: [
    {"to laugh": ["lachen", "lache", "lachst", "lacht", "lacht", "lacht", "lachen", "lacht", "lachen", "lachen"]},
    {"to run": ["laufen", "laufe", "läufst", "läuft", "läuft", "läuft", "laufen", "lauft", "laufen", "laufen"]},
    {"to live": ["leben", "lebe", "lebst", "lebt", "lebt", "lebt", "leben", "lebt", "leben", "leben"]},
    {"to put, to lay": ["legen", "lege", "legst", "legt", "legt", "legt", "legen", "legt", "legen", "legen"]},
    {"to learn": ["lernen", "lerne", "lernst", "lernt", "lernt", "lernt", "lernen", "lernt", "lernen", "lernen"]},
    {"to read": ["lesen", "lese", "liest", "liest", "liest", "liest", "lesen", "lest", "lesen", "lesen"]},
    {"to love": ["lieben", "liebe", "liebst", "liebt", "liebt", "liebt", "lieben", "liebt", "lieben", "lieben"]},
    {"to lie, to be located": ["liegen", "liege", "liegst", "liegt", "liegt", "liegt", "liegen", "liegt", "liegen", "liegen"]}
  ],
  examples: {
    nominative: [
      {
        german: '___ Laden ist offen.',
        english: 'The shop is open.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Leben ist schön.',
        english: 'Life is beautiful.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Lehrer kommt.',
        english: 'The teacher is coming.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Licht ist hell.',
        english: 'The light is bright.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Lied ist populär.',
        english: 'The song is popular.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Lösung ist einfach.',
        english: 'The solution is easy.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Lokal ist voll.',
        english: 'The restaurant is full.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Leute sind freundlich.',
        english: 'The people are friendly.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Lkw ist groß.',
        english: 'The truck is large.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Land ist grün.',
        english: 'The country is green.',
        answer: 'Das',
        case: 'nominative'
      }
    ],
    accusative: [
      {
        german: 'Ich kaufe ___ Land.',
        english: 'I buy the country.',
        answer: 'das',
        case: 'accusative'
      },
      {
        german: 'Sie besucht ___ Lehrer.',
        english: 'She visits the teacher.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Er braucht ___ Lösung.',
        english: 'He needs the solution.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Wir sehen ___ Licht.',
        english: 'We see the light.',
        answer: 'das',
        case: 'accusative'
      },
      {
        german: 'Du hörst ___ Lied.',
        english: 'You hear the song.',
        answer: 'das',
        case: 'accusative'
      },
      {
        german: 'Ich liebe ___ Leben.',
        english: 'I love life.',
        answer: 'das',
        case: 'accusative'
      },
      {
        german: 'Er findet ___ Laden.',
        english: 'He finds the shop.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Sie kauft ___ Lebensmittel.',
        english: 'She buys the food.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Wir benutzen ___ Lkw.',
        english: 'We use the truck.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Du wählst ___ Lokal.',
        english: 'You choose the restaurant.',
        answer: 'das',
        case: 'accusative'
      }
    ],
    dative: [
      {
        german: 'Ich helfe ___ Lehrer.',
        english: 'I help the teacher.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Sie geht zu ___ Laden.',
        english: 'She goes to the shop.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Er spricht mit ___ Leuten.',
        english: 'He speaks with the people.',
        answer: 'den',
        case: 'dative'
      },
      {
        german: 'Wir danken ___ Lehrer.',
        english: 'We thank the teacher.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Du sitzt in ___ Lokal.',
        english: 'You sit in the restaurant.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Er gibt ___ Kind ___ Lied.',
        english: 'He gives the child the song.',
        answer: 'dem das',
        case: 'dative'
      },
      {
        german: 'Sie arbeitet für ___ Lehrer.',
        english: 'She works for the teacher.',
        answer: 'den',
        case: 'dative'
      },
      {
        german: 'Ich komme aus ___ Land.',
        english: 'I come from the country.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Wir leben in ___ Land.',
        english: 'We live in the country.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Du gehst zu ___ Leute.',
        english: 'You go to the people.',
        answer: 'den',
        case: 'dative'
      }
    ],
    translations: [
      {
        english: 'The shop is open.',
        german: ['Der Laden ist offen.', 'Das Geschäft ist offen.'],
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'Life is beautiful.',
        german: 'Das Leben ist schön.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'She loves the song.',
        german: 'Sie liebt das Lied.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'I help the teacher.',
        german: 'Ich helfe dem Lehrer.',
        type: 'translation',
        caseType: 'dative'
      },
      {
        english: 'They live in the country.',
        german: 'Sie leben im Land.',
        type: 'translation',
        caseType: 'dative'
      },
      {
        english: 'The teacher laughs.',
        german: 'Der Lehrer lacht.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'We learn the song.',
        german: 'Wir lernen das Lied.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'The people read the book.',
        german: 'Die Leute lesen das Buch.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'You run to the shop.',
        german: 'Du läufst zum Laden.',
        type: 'translation',
        caseType: 'dative'
      },
      {
        english: 'He puts the light on the table.',
        german: 'Er legt das Licht auf den Tisch.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'The solution is correct.',
        german: 'Die Lösung ist richtig.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'I love my life.',
        german: 'Ich liebe mein Leben.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'The truck is big.',
        german: 'Der Lkw ist groß.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'She sits in the restaurant.',
        german: 'Sie sitzt im Lokal.',
        type: 'translation',
        caseType: 'dative'
      },
      {
        english: 'We buy the food.',
        german: 'Wir kaufen die Lebensmittel.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'The teacher reads the letter.',
        german: 'Der Lehrer liest den Brief.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'I lie in bed.',
        german: 'Ich liege im Bett.',
        type: 'translation',
        caseType: 'dative'
      },
      {
        english: 'The people laugh.',
        german: 'Die Leute lachen.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'We run to the shop.',
        german: 'Wir laufen zum Laden.',
        type: 'translation',
        caseType: 'dative'
      },
      {
        english: 'She lives in the country.',
        german: 'Sie lebt auf dem Land.',
        type: 'translation',
        caseType: 'dative'
      },
      {
        english: 'He puts the book on the table.',
        german: 'Er legt das Buch auf den Tisch.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'I learn the solution.',
        german: 'Ich lerne die Lösung.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'He puts the book on the table.',
        german: 'Er legt das Buch auf den Tisch.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'I learn the solution.',
        german: 'Ich lerne die Lösung.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'The teacher reads the letter.',
        german: 'Der Lehrer liest den Brief.',
        type: 'translation',
        caseType: 'accusative'
      }
    ],
    conjugations: [
      {
        question: 'How do you conjugate "to laugh" for "I"?',
        answer: 'lache',
        verb: 'lachen',
        verbEnglish: 'to laugh',
        subject: 'ich',
        conjugation: 'lache'
      },
      {
        question: 'How do you conjugate "to run" for "you" (informal)?',
        answer: 'läufst',
        verb: 'laufen',
        verbEnglish: 'to run',
        subject: 'du',
        conjugation: 'läufst'
      },
      {
        question: 'How do you conjugate "to live" for "he"?',
        answer: 'lebt',
        verb: 'leben',
        verbEnglish: 'to live',
        subject: 'er',
        conjugation: 'lebt'
      },
      {
        question: 'How do you conjugate "to put" for "we"?',
        answer: 'legen',
        verb: 'legen',
        verbEnglish: 'to put, to lay',
        subject: 'wir',
        conjugation: 'legen'
      },
      {
        question: 'How do you conjugate "to learn" for "they"?',
        answer: 'lernen',
        verb: 'lernen',
        verbEnglish: 'to learn',
        subject: 'sie',
        conjugation: 'lernen'
      },
      {
        question: 'What is the simple past of "to laugh" for "I"?',
        answer: 'lachte',
        verb: 'lachen',
        verbEnglish: 'to laugh',
        subject: 'ich',
        conjugation: 'lachte'
      },
      {
        question: 'What is the simple past of "to run" for "she"?',
        answer: 'lief',
        verb: 'laufen',
        verbEnglish: 'to run',
        subject: 'sie',
        conjugation: 'lief'
      },
      {
        question: 'What is the simple past of "to live" for "he"?',
        answer: 'lebte',
        verb: 'leben',
        verbEnglish: 'to live',
        subject: 'er',
        conjugation: 'lebte'
      },
      {
        question: 'What is the simple past of "to put" for "we"?',
        answer: 'legten',
        verb: 'legen',
        verbEnglish: 'to put, to lay',
        subject: 'wir',
        conjugation: 'legten'
      },
      {
        question: 'What is the simple past of "to learn" for "they"?',
        answer: 'lernten',
        verb: 'lernen',
        verbEnglish: 'to learn',
        subject: 'sie',
        conjugation: 'lernten'
      },
      {
        question: 'How do you conjugate "to read" for "I"?',
        answer: 'lese',
        verb: 'lesen',
        verbEnglish: 'to read',
        subject: 'ich',
        conjugation: 'lese'
      },
      {
        question: 'How do you conjugate "to love" for "she"?',
        answer: 'liebt',
        verb: 'lieben',
        verbEnglish: 'to love',
        subject: 'sie',
        conjugation: 'liebt'
      },
      {
        question: 'How do you conjugate "to lie" for "we"?',
        answer: 'liegen',
        verb: 'liegen',
        verbEnglish: 'to lie, to be located',
        subject: 'wir',
        conjugation: 'liegen'
      },
      {
        question: 'What is the simple past of "to read" for "I"?',
        answer: 'las',
        verb: 'lesen',
        verbEnglish: 'to read',
        subject: 'ich',
        conjugation: 'las'
      },
      {
        question: 'What is the simple past of "to love" for "she"?',
        answer: 'liebte',
        verb: 'lieben',
        verbEnglish: 'to love',
        subject: 'sie',
        conjugation: 'liebte'
      },
      {
        question: 'What is the simple past of "to lie" for "we"?',
        answer: 'lagen',
        verb: 'liegen',
        verbEnglish: 'to lie, to be located',
        subject: 'wir',
        conjugation: 'lagen'
      }
    ]
  }
}
